/* eslint-disable react/prop-types */
import './LoadingIndicator.scss';

function LoadingIndicator({children, isLoading}) {
    const getClassnames = () => (isLoading ? 'loadingIndicator loadingIndicator--isLoading' : 'loadingIndicator');
    return (
        <div className={getClassnames()}>
            <div className="loadingIndicator__content">{children}</div>
            <span className="loadingIndicator__spinner" />
        </div>
    );
}

export default LoadingIndicator;
